import React from "react";
import "./PGAModelBuilderField.css";
import { graphql, useLazyLoadQuery } from "react-relay";
import StatTable from "../../../../../StatTable";

const GET_FIELD = graphql`
  query PGAModelBuilderFieldQuery($slateId: ID!) {
    playersForSlate(slateId: $slateId) {
      player {
        name
        shortenedName
      }

      salary
    }
  }
`;

export default function PGAModelBuilderField(props) {
  if (!props.slateId) {
    return <></>;
  }

  const data = useLazyLoadQuery(GET_FIELD, { slateId: props.slateId });

  const columns = [
    {
      Header: "Player",
      accessor: "playerName",
    },
    {
      Header: "Salary",
      accessor: "salary",
    },
  ];

  const tableData = React.useMemo(
    () =>
      data.playersForSlate.map((slatePlayer) => {
        return {
          playerName: slatePlayer.player.name,
          salary: slatePlayer.salary,
        };
      }),
    []
  );

  const tableMemo = React.useMemo(() => {
    return <StatTable columns={columns} data={tableData} paginate={true} />;
  }, []);

  return <div className="pga-model-builder-field-container">{tableMemo} </div>;
}
